import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useHeaderNavigation } from '../hooks/useHeaderNavigation';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_blood-test-kit/artifacts/1ev5dw09_IWMC_logo_transparent.png';
const links = [
  { id: 'how-it-works', label: 'How It Works', to: '/#how-it-works' },
  { id: 'test-kits', label: 'View Panels', to: '/#shop' },
  { id: 'protocol', label: 'Your Protocol', to: '/#protocol' },
  { id: 'why-us', label: 'Why Us', to: '/#why' },
  { id: 'lab-marker-guide', label: 'Lab Marker Guide', to: '/results' },
  { id: 'ask-yara', label: 'Ask Yara', to: '/yara' },
  { id: 'faq', label: 'FAQ', to: '/#faq' },
];

export default function Header() {
  const { open, forceMenu, rowRef, navRef, toggle, close, location } = useHeaderNavigation();
  const renderLinks = (prefix) => links.map(({ id, label, to }) => (
    <Link key={id} to={to} className="hbk-nav-link" onClick={close} aria-current={`${location.pathname}${location.hash}` === to ? 'page' : undefined} data-testid={`${prefix}-${id}`}>{label}</Link>
  ));
  return (
    <header className="hbk-header" data-menu-collapsed={forceMenu ? 'true' : 'false'} data-testid="site-header">
      <a href="#main-content" className="hbk-skip-link" data-testid="skip-to-content">Skip to content</a>
      <div className="hbk-utility">
        <div className="hbk-header-inner flex items-center justify-between gap-3">
          <a href="tel:+12015353582" data-testid="topbar-phone">(201) 535-3582</a>
        </div>
      </div>
      <div ref={rowRef} className="hbk-header-inner hbk-header-row">
        <Link to="/" className="hbk-brand" data-testid="logo-link"><img src={LOGO_URL} alt="Integrated Wellness" width="44" height="44" /><span>HomeBloodKit</span></Link>
        <nav ref={navRef} className="hbk-desktop-nav" aria-label="Main navigation" data-testid="desktop-navigation">{renderLinks('nav')}</nav>
        <Link to="/order" className="btn-cta hbk-short-cta hbk-header-cta" data-testid="header-customize-cta">FIND MY PANEL</Link>
        <button id="hbk-menu-toggle" className="hbk-menu-toggle" onClick={toggle} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? 'Close navigation menu' : 'Open navigation menu'} data-testid="mobile-menu-toggle">{open ? <X size={26} /> : <Menu size={26} />}</button>
      </div>
      {open && <nav id="mobile-menu" className="hbk-mobile-nav" aria-label="Mobile navigation" data-testid="mobile-menu">{renderLinks('mobile-nav')}<Link to="/order" onClick={close} className="btn-cta hbk-short-cta mt-3" data-testid="mobile-customize-cta">FIND MY PANEL</Link></nav>}
    </header>
  );
}